import { API, API_POST } from "../../Config";

export const handleAddProductCategory = (category, id) => {
  const f = new FormData();
  f.append("category", category);

  if (id) {
    
    f.append("id", id);
    return API_POST(API.updateproductcategory, f);
  }

  return API_POST(API.addproductcategory, f);
};
